module.exports = __webpack_public_path__ + "img/chevron-down.327e202e.svg";